import {
  CREATE_EVENT_DATA,
  EVENT_HOSTING_DRAFT,
  DATA_FIREBASE,
  DEBUG_MODE,
  DEBUG_SCOPE,
  DEVICE_USER,
  GROUP_ID_SELECTED,
  LIST_EVENT,
  LIST_GROUP,
  LIST_MY_EVENT,
  LIST_ORDER,
  LIST_PUBLIC_GROUP,
  NAV_TABS_QTY,
  SOCIAL_TOKEN,
  USER_INFO,
  USER_TOKEN,
  SORT_EVENT_TYPE,
  SHOW_ALL_MY_EVENT,
  IS_CREATE_PACKING_LIST,
  USER_TOKEN_TO_PAY,
  PAY_ON_LINK_SHARE,
  USER_INFO_TEMPORARY,
  REMIND_PAYMENT_MESSAGE,
  UPDATES_POPUP_SEEN_INACTIVE_GROUP,
  MY_PURCHASE_FILTER_TAB,
  REDIRECT_AFTER_LOGIN,
} from './constant'

export const setIsShowAllEventOping = (value) => {
  localStorage.setItem(SHOW_ALL_MY_EVENT, JSON.stringify(value))
}

export const getIsShowAllEventOping = () => {
  const value = localStorage.getItem(SHOW_ALL_MY_EVENT)
  try {
    if (value) {
      return JSON.parse(value)
    }
    return null
  } catch (error) {
    return value
  }
}

export const setSortTypeEvent = (value) => {
  localStorage.setItem(SORT_EVENT_TYPE, JSON.stringify(value))
}

export const getSortTypeEvent = () => {
  const value = localStorage.getItem(SORT_EVENT_TYPE)
  try {
    if (value) {
      return JSON.parse(value)
    }
    return null
  } catch (error) {
    return value
  }
}

export const removeIsCreatePackingList = () => {
  localStorage.removeItem(IS_CREATE_PACKING_LIST)
}

export const setUserToken = (value) => {
  localStorage.setItem(USER_TOKEN, JSON.stringify(value))
}

export const setUserTokenToPay = (value) => {
  localStorage.setItem(USER_TOKEN_TO_PAY, JSON.stringify(value))
}

export const setPayOnLinkShareMode = () => {
  localStorage.setItem(PAY_ON_LINK_SHARE, true)
}

export const getTokenTemporary = () => {
  const value = localStorage.getItem(USER_TOKEN_TO_PAY)
  try {
    if (value) {
      return JSON.parse(value)
    }
    return null
  } catch (error) {
    return value
  }
}

export const getPayOnLinkShareMode = () => {
  const value = localStorage.getItem(PAY_ON_LINK_SHARE)
  try {
    if (value) {
      return JSON.parse(value)
    }
    return null
  } catch (error) {
    return value
  }
}

export const removePayOnLinkShareMode = () => {
  localStorage.removeItem(PAY_ON_LINK_SHARE)
  localStorage.removeItem(USER_TOKEN_TO_PAY)
  localStorage.removeItem(USER_INFO_TEMPORARY)
}

export const setGroupIdSelected = (value) => {
  localStorage.setItem(GROUP_ID_SELECTED, value)
}

export const getGroupIdSelected = () => localStorage.getItem(GROUP_ID_SELECTED)

// Session-scoped so an abandoned sign-in doesn't redirect a later, unrelated login
export const setRedirectAfterLogin = (path) => {
  sessionStorage.setItem(REDIRECT_AFTER_LOGIN, path)
}

export const getRedirectAfterLogin = () => sessionStorage.getItem(REDIRECT_AFTER_LOGIN)

export const removeRedirectAfterLogin = () => {
  sessionStorage.removeItem(REDIRECT_AFTER_LOGIN)
}

export const getUserToken = () => {
  const value = localStorage.getItem(USER_TOKEN)
  if (!value || value === 'undefined' || value === 'null') {
    return null
  }
  try {
    return JSON.parse(value)
  } catch (error) {
    return value
  }
}

export const getRemindPaymentMessage = () => {
  const value = localStorage.getItem(REMIND_PAYMENT_MESSAGE)
  try {
    if (value) {
      return JSON.parse(value)
    }
    return null
  } catch (error) {
    return value
  }
}

export const setRemindPaymentMessage = (value) => {
  localStorage.setItem(REMIND_PAYMENT_MESSAGE, JSON.stringify(value))
}

export const removeUserToken = () => {
  localStorage.removeItem(USER_TOKEN)
}

export const setUserTemporary = (value) => {
  localStorage.setItem(USER_INFO_TEMPORARY, JSON.stringify(value))
}

export const setUserInfo = (value) => {
  if (!value || value === 'undefined') {
    localStorage.removeItem(USER_INFO)
    return
  }
  localStorage.setItem(USER_INFO, JSON.stringify(value))
}

export const getUserInfo = () => {
  const isPayWithLinkShare = localStorage.getItem('PAY_ON_LINK_SHARE')
  const key = isPayWithLinkShare ? USER_INFO_TEMPORARY : USER_INFO
  const value = localStorage.getItem(key)

  if (!value || value === 'undefined' || value === 'null') {
    localStorage.removeItem(key)
    return null
  }

  try {
    return JSON.parse(value)
  } catch (error) {
    localStorage.removeItem(key)
    return null
  }
}

export const setSocialToken = (value) => {
  localStorage.setItem(SOCIAL_TOKEN, JSON.stringify(value))
}

export const getSocialToken = () => {
  const value = localStorage.getItem(SOCIAL_TOKEN)
  try {
    if (value) {
      return JSON.parse(value)
    }
    return null
  } catch (error) {
    return value
  }
}

export const removeSocialToken = () => {
  localStorage.removeItem(SOCIAL_TOKEN)
}

export const setListGroup = (value) => {
  localStorage.setItem(LIST_GROUP, JSON.stringify(value))
}

export const getListGroup = () => {
  const value = localStorage.getItem(LIST_GROUP)
  try {
    if (value) {
      return JSON.parse(value)
    }
    return null
  } catch (error) {
    return value
  }
}

export const removeListGroup = () => {
  localStorage.removeItem(LIST_GROUP)
}

export const setListPublicGroups = (value) => {
  localStorage.setItem(LIST_PUBLIC_GROUP, JSON.stringify(value))
}

export const getListPublicGroups = () => {
  const value = localStorage.getItem(LIST_PUBLIC_GROUP)
  try {
    if (value) {
      return JSON.parse(value)
    }
    return null
  } catch (error) {
    return value
  }
}

export const setListEvents = (value) => {
  localStorage.setItem(LIST_EVENT, JSON.stringify(value))
}

export const getListEvents = () => {
  const value = localStorage.getItem(LIST_EVENT)
  try {
    if (value) {
      return JSON.parse(value)
    }
    return null
  } catch (error) {
    return value
  }
}

export const setListMyEvents = (value) => {
  localStorage.setItem(LIST_MY_EVENT, JSON.stringify(value))
}

export const getListMyEvents = () => {
  const value = localStorage.getItem(LIST_MY_EVENT)
  try {
    if (value) {
      return JSON.parse(value)
    }
    return null
  } catch (error) {
    return value
  }
}

export const setListOrders = (value) => {
  localStorage.setItem(LIST_ORDER, JSON.stringify(value))
}

export const getListOrders = () => {
  const value = localStorage.getItem(LIST_ORDER)
  try {
    if (value) {
      return JSON.parse(value)
    }
    return null
  } catch (error) {
    return value
  }
}
export const setDataFirebase = (value) => {
  localStorage.setItem(DATA_FIREBASE, JSON.stringify(value))
}

export const getDataFirebase = () => {
  const value = localStorage.getItem(DATA_FIREBASE)
  try {
    if (value) {
      return JSON.parse(value)
    }
    return null
  } catch (error) {
    return value
  }
}

export const setListOrder = (value) => {
  localStorage.setItem(LIST_ORDER, JSON.stringify(value))
}

export const setCreateEventData = (value) => {
  localStorage.setItem(CREATE_EVENT_DATA, JSON.stringify(value))
}

export const getCreateEventData = () => {
  const value = localStorage.getItem(CREATE_EVENT_DATA)
  try {
    if (value) {
      return JSON.parse(value)
    }
    return null
  } catch (error) {
    return value
  }
}

export const removeCreateEventData = () => {
  localStorage.removeItem(CREATE_EVENT_DATA)
}

export const setEventHostingDraft = (value) => {
  localStorage.setItem(EVENT_HOSTING_DRAFT, JSON.stringify(value))
}

export const getEventHostingDraft = () => {
  const value = localStorage.getItem(EVENT_HOSTING_DRAFT)
  try {
    if (value) {
      return JSON.parse(value)
    }
    return null
  } catch (error) {
    return null
  }
}

export const removeEventHostingDraft = () => {
  localStorage.removeItem(EVENT_HOSTING_DRAFT)
}

export const setDebugMode = (isDebug) => {
  localStorage.setItem(DEBUG_MODE, isDebug)
}

export const getDebugMode = () => localStorage.getItem(DEBUG_MODE)

export const setDebugScope = (userEmails) => {
  localStorage.setItem(DEBUG_SCOPE, userEmails)
}

export const getDebugScope = () => localStorage.getItem(DEBUG_SCOPE)
export const setDeviceUser = (value) => localStorage.setItem(DEVICE_USER, value)
export const getDeviceUser = () => localStorage.getItem(DEVICE_USER)

export const setDomain = (key, value) => {
  localStorage.setItem(key, value)
}
export const getDomain = (key) => localStorage.getItem(key)

export const setIsShowPopupSeenInactiveGroup = (value) => {
  localStorage.setItem(UPDATES_POPUP_SEEN_INACTIVE_GROUP, JSON.stringify(value))
}

export const getIsShowPopupSeenInactiveGroup = () => {
  const value = localStorage.getItem(UPDATES_POPUP_SEEN_INACTIVE_GROUP)
  try {
    if (value) {
      return JSON.parse(value)
    }
    return null
  } catch (error) {
    return value
  }
}

// Next time you want to show the user a new popup, just upgrade to the version ...NOTIFICATION_V2
const SHARE_EVENT_NOTIFICATION = 'EVENT_DISCOUNT_FEATURE_NOTIFICATION_V1'

export const getShareEventNotification = () => {
  const value = localStorage.getItem(SHARE_EVENT_NOTIFICATION)
  try {
    if (value) {
      return JSON.parse(value)
    }
    return null
  } catch (error) {
    return value
  }
}

export const setShareEventNotification = (value) => {
  localStorage.setItem(SHARE_EVENT_NOTIFICATION, JSON.stringify(value))
}

export const getNavTabsQty = () => {
  const value = localStorage.getItem(NAV_TABS_QTY)
  try {
    return value ? JSON.parse(value) : null
  } catch (error) {
    return null
  }
}

export const setNavTabsQty = (value) => {
  localStorage.setItem(NAV_TABS_QTY, JSON.stringify({ ...getNavTabsQty(), ...value }))
}

export const getMyPurchaseFilterTab = () => {
  const value = localStorage.getItem(MY_PURCHASE_FILTER_TAB)
  try {
    return value ? JSON.parse(value) : null
  } catch (error) {
    return value
  }
}

export const setMyPurchaseFilterTab = (value) => {
  localStorage.setItem(MY_PURCHASE_FILTER_TAB, JSON.stringify(value))
}
